//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgSearch } from '../icons/Search';

export function SearchIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgSearch} data-qa="SearchIcon">
      <svg />
    </SvgIcon>
  );
}
